export const DEFAULT_ACCOUNTING_ROWS_PER_PAGE = 10;

export const DASHBOARD_CHART_COLORS = [
  '#5e894f',
  '#ef6c00',
  '#0288d1',
  '#d44242',
  '#7b1fa2',
  '#00897b',
  '#f9a825',
  '#3949ab',
  '#c2185b',
  '#455a64',
];

export const ACCOUNTING_STATUS_CONFIG = {
  draft: { label: 'Borrador', color: 'default' },
  posted: { label: 'Contabilizado', color: 'success' },
  cancelled: { label: 'Anulado', color: 'error' },
};

export const ACCOUNTING_ORIGIN_LABELS = {
  supplier_account_adjustment: 'Ajuste proveedor',
  payment_order: 'Orden de pago',
  supplier_invoice: 'Factura proveedor',
  manual: 'Manual',
};

export const ACCOUNTING_SOURCE_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'manual', label: 'Manual' },
  { value: 'supplier_invoice', label: 'Factura proveedor' },
  { value: 'payment_order', label: 'Orden de pago' },
  { value: 'supplier_account_adjustment', label: 'Ajuste proveedor' },
];

export const ACCOUNTING_STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'draft', label: 'Borrador' },
  { value: 'posted', label: 'Contabilizado' },
  { value: 'cancelled', label: 'Anulado' },
];

export const ENTRY_DRAWER_SECTIONS = [
  { id: 'datos', label: 'Datos' },
  { id: 'lineas', label: 'Líneas contables' },
  { id: 'resumen', label: 'Resumen' },
];

export const ENTRY_DETAIL_SECTIONS = [
  { id: 'detalle', label: 'Detalle' },
  { id: 'lineas', label: 'Líneas contables' },
  { id: 'totales', label: 'Totales' },
];

export const ACCOUNTING_DRAWER_WIDTH = { xs: '100vw', md: 'min(944px, calc(100vw - 40px))' };

export const INITIAL_ACCOUNTING_FILTERS = {
  source_type: '',
  status: '',
  start_date: '',
  end_date: '',
};
